import { FilteredItem } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';

import { useEmspBoEmspLocationListContext } from '../../emsp-bo-location.context';
import {
  EMSP_BO_LOCATION_LIST_FILTER,
  EMSP_BO_LOCATION_LIST_FILTER_NAME_LIST,
} from '../emsp-bo-location-list.config';
import * as css from './emsp-bo-location-list-filter-state.module.scss';

export const EmspBoLocationListFilterStateController =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
      useEmspBoEmspLocationListContext();

    // HANDLERS //////////////////////////////////////////////////////////////////

    const handleRemove = <K extends keyof GetLocationsPaginatedModel>(
      filterName: K,
      filterValue: GetLocationsPaginatedModel[K],
    ): void => {
      setGetPaginatedQueryParameters((current) => {
        const currentValue = current[filterName];

        if (Array.isArray(currentValue) && !Array.isArray(filterValue)) {
          return {
            ...current,
            [filterName]: currentValue.filter((item) => item !== filterValue),
          };
        }

        // cpoId est requis (string, pas undefined) — on remet à ''
        if (filterName === 'cpoId') {
          return { ...current, cpoId: '' };
        }

        return { ...current, [filterName]: undefined };
      });
    };

    // RENDER ////////////////////////////////////////////////////////////////////

    // On exclut les valeurs vides ('') pour cpoId
    const filterNameActiveList = EMSP_BO_LOCATION_LIST_FILTER_NAME_LIST.filter(
      (filterName) => {
        const value = getPaginatedQueryParameters[filterName];
        return value !== undefined && value !== '';
      },
    );

    return (
      <Stack
        className={css.filtersSection}
        flex={1}
        gap={GapEnum.S}
        justifyContent="space-between"
        alignItems="center">
        <Stack
          direction="row"
          className={css.displayedFiltersSection}
          gap={GapEnum.S}
          alignItems="center"
          flex={1}>
          {filterNameActiveList
            .flatMap((filterName) => {
              const filterValue = getPaginatedQueryParameters[filterName];

              if (filterValue === undefined) {
                return [];
              }

              const FilteredItemComponent =
                EMSP_BO_LOCATION_LIST_FILTER[filterName]?.componentType;

              if (Array.isArray(filterValue)) {
                return filterValue.map((item) => {
                  if (FilteredItemComponent) {
                    return (
                      <FilteredItemComponent
                        key={`${filterName}-${item}`}
                        value={item}
                        onRemove={() => handleRemove(filterName, item)}
                      />
                    );
                  }
                  return (
                    <FilteredItem
                      key={`${filterName}-${item}`}
                      label={`${item}`}
                      onRemove={() => handleRemove(filterName, item)}
                    />
                  );
                });
              }

              if (FilteredItemComponent) {
                return [
                  <FilteredItemComponent
                    key={filterName}
                    value={filterValue}
                    onRemove={() => handleRemove(filterName, filterValue)}
                  />,
                ];
              }

              return [
                <FilteredItem
                  key={filterName}
                  label={`${filterValue}`}
                  onRemove={() => handleRemove(filterName, filterValue)}
                />,
              ];
            })
            .slice(0, 3)}
        </Stack>
      </Stack>
    );
  };
